module.exports = __webpack_public_path__ + "static/img/award5.4b9bc19.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award5.png
// module id = LwUo
// module chunks = 7